import React from 'react';
import './CircleTimer.css';

// Timer badge shown during timed phases (Crayonbox sticker pill).
// Mirrors TimerBadge in PictaphoneiOS/.../Components/TimerView.swift: a small
// pie that sweeps clockwise as time elapses, plus the seconds, inside a white
// ink-bordered pill with a hard offset shadow.
function CircleTimer({ timeLeft, maxTime, size = 18 }) {
  // maxTime === 0 means no-limit mode — show ∞ symbol instead of timer
  if (maxTime === 0) {
    return (
      <span className="timer-badge timer-badge--nolimit" aria-label="No time limit">
        <span className="timer-badge-text">∞</span>
      </span>
    );
  }

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2;
  const progress = maxTime > 0 ? Math.max(0, Math.min(1, timeLeft / maxTime)) : 0;
  const urgent = timeLeft <= 10;

  let fillShape = null;
  if (progress >= 1) {
    fillShape = <circle cx={cx} cy={cy} r={r} className="timer-badge-pie" />;
  } else if (progress > 0) {
    const startAngle = (1 - progress) * 2 * Math.PI;
    const startX = cx + r * Math.sin(startAngle);
    const startY = cy - r * Math.cos(startAngle);
    const largeArcFlag = progress > 0.5 ? 1 : 0;
    const d = `M ${cx} ${cy} L ${startX} ${startY} A ${r} ${r} 0 ${largeArcFlag} 1 ${cx} ${cy - r} Z`;
    fillShape = <path d={d} className="timer-badge-pie" />;
  }

  // Inset the border stroke so it sits inside the circle like SwiftUI's strokeBorder.
  const strokeW = 1.5;

  return (
    <span
      className={`timer-badge${urgent ? ' urgent' : ''}`}
      role="timer"
      aria-label={`${timeLeft} seconds left`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="timer-badge-ring" aria-hidden="true">
        <circle cx={cx} cy={cy} r={r} className="timer-badge-track" />
        {fillShape}
        <circle cx={cx} cy={cy} r={r - strokeW / 2} className="timer-badge-border" strokeWidth={strokeW} />
      </svg>
      <span className="timer-badge-text">{timeLeft}s</span>
    </span>
  );
}

export default CircleTimer;
